import {useGetImage} from '@api'
import {getUserData, roles, useViewNavigate} from '@common'
import {ImageType, LocalStorageItem, NavigationPathKey, TranslationKey} from '@enums'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import {Menu, Stack, Typography} from '@mui/material'

import React, {useState} from 'react'

import {useTranslation} from 'react-i18next'

import {
  Avatar,
  MenuItemStyled,
  Separator,
  StyledButton,
  StyledStack,
  UserRole,
  UserTitle,
  imageStyle,
  menuSlotStyle,
} from './style'

export function UserMenuButton() {
  const currentUser = getUserData()
  const {fullName, role, id} = currentUser || {}
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [showImage, setShowImage] = useState(true)
  const navigate = useViewNavigate()
  const {t} = useTranslation()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const logout = () => {
    setAnchorEl(null)
    localStorage.removeItem(LocalStorageItem.AUTHENTICATION)
    navigate(NavigationPathKey.LOGOUT)
  }

  const getAvatarInitials = (fullName: string) => {
    return fullName
      ? fullName
          .split(' ')
          .map(word => word[0])
          .join('')
      : ''
  }

  const {data: image} = useGetImage(ImageType.USER, id)

  return (
    <>
      <StyledButton onClick={handleClick}>
        {showImage ? (
          <img src={image} alt="User image" style={imageStyle} onError={() => setShowImage(false)} />
        ) : (
          <Avatar>
            <Typography>{getAvatarInitials(fullName)}</Typography>
          </Avatar>
        )}
      </StyledButton>

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: menuSlotStyle,
          },
        }}
      >
        <MenuItemStyled onClick={() => navigate(`${NavigationPathKey.USER_VIEW}/${id}`)}>
          <Stack>
            <UserTitle>{fullName}</UserTitle>
            <UserRole>{roles(t).find(item => item.code === role)?.name}</UserRole>
          </Stack>
        </MenuItemStyled>
        <Separator />
        <MenuItemStyled onClick={logout}>
          <StyledStack>
            <Typography>{t(TranslationKey.Logout)}</Typography>
            <LogoutOutlinedIcon />
          </StyledStack>
        </MenuItemStyled>
      </Menu>
    </>
  )
}
